import { DemoButton } from '@web/components/DemoButton'

type SolutionsHeaderProps = {
  header: React.ReactNode
  descriptionLeft: React.ReactNode
  descriptionRight: React.ReactNode
  arcadeLink?: { src: string; title: string }
  subheader?: string
  guideLink?: string
  logo?: { src: string; alt: string }
  ctaLabel?: string
  eyebrow?: string
  aboveArcade?: React.ReactNode
}

const SolutionsHeader = ({
  header,
  arcadeLink,
  descriptionLeft,
  descriptionRight,
  subheader,
  guideLink,
  logo,
  ctaLabel,
  eyebrow,
  aboveArcade,
}: SolutionsHeaderProps) => {
  return (
    <section className="bg-neutral-muted py-24 sm:py-16 px-6">
      <div className="space-y-8 mx-auto max-w-5xl lg:px-8">
        {eyebrow && (
          <p className="text-xs font-semibold uppercase tracking-widest text-brand-blue m-0">
            {eyebrow}
          </p>
        )}
        {logo && <img src={logo.src} alt={logo.alt} className="h-12 md:h-14 w-auto" />}
        <h1 className="text-4xl font-light text-brand-blue">{header}</h1>
        <div className="flex flex-col-reverse flex-wrap gap-16">
          <div className="mb-0 mx-auto grow-1 md:mb-4 w-full md:mx-0 h-auto">
            {arcadeLink && (
              <iframe
                src={arcadeLink.src}
                title={arcadeLink.title}
                className="inset-0 border-0 w-full rounded-lg shadow-2xl h-auto aspect-[1.96/1] mt-1"
                loading="lazy"
                allowFullScreen
                allow="clipboard-write"
              />
            )}
          </div>
          {aboveArcade && <div>{aboveArcade}</div>}
          <div className="space-y-4 text-lg leading-relaxed text-text-secondary lg:text-xl flex-1 pr-4">
            {subheader && (
              <span className="text-lg font-bold text-brand-blue pr-8">{subheader}</span>
            )}
            <div className="grid gap-12 gap-y-4 md:grid-cols-2">
              <div className="text-base text-brand-navy space-y-4">{descriptionLeft}</div>
              <div className="text-base text-brand-navy space-y-4">{descriptionRight}</div>
            </div>
          </div>
        </div>
        <div className="flex gap-4">
          <DemoButton label={ctaLabel} />
          {guideLink && (
            <button
              className="px-8 py-3 text-sm font-semibold text-white no-underline transition-colors rounded bg-brand-blue border-0 cursor-pointer hover:bg-brand-navy"
              onClick={() => window.open(guideLink, '_blank')}
            >
              Download Guide
            </button>
          )}
        </div>
      </div>
    </section>
  )
}

export default SolutionsHeader
